export type VoiceProduct = 'bos' | 'hos';

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function wakeTerms(product: VoiceProduct, assistantName: string): string[] {
  const productTerms = product === 'hos'
    ? ['hos', 'house', 'home']
    : ['bos', 'boss'];
  const configuredName = assistantName.replace(/\s+/g, ' ').trim().toLowerCase();
  return [...new Set([...productTerms, configuredName].filter(Boolean))]
    .sort((left, right) => right.length - left.length);
}

/**
 * Extract the command that follows a product or configured-assistant wake
 * phrase. Speech recognition commonly renders BOS as "boss" and HOS as
 * "house", so both phonetic forms are intentionally accepted.
 */
export function extractVoiceCommand(
  raw: string,
  product: VoiceProduct,
  assistantName: string,
): string {
  const aliases = wakeTerms(product, assistantName).map(escapeRegExp).join('|');
  if (!aliases) return '';
  const match = raw.trim().match(
    new RegExp(`(?:^|\\b)(?:${aliases})(?:\\b|(?=[\\s,:.!?\\-]|$))[\\s,:.!?\\-]*(.*)$`, 'i'),
  );
  return match?.[1]?.trim() ?? '';
}

export function voiceSurfaceCopy(product: VoiceProduct) {
  const label = product.toUpperCase();
  return {
    label,
    failure: `Can't reach ${label} right now.`,
    mutedTitle: `Talk to ${label}`,
    activeTitle: `Mute ${label}`,
  } as const;
}
